import { ConfigProvider, theme } from "antd";
import { createContext, useContext, useEffect, useState } from "react";
import fa_IR from "antd/lib/locale/fa_IR";
const ThemeContext = createContext();
export const ThemeContextProvider = ({ children }) => {
	const [darkMode, setDarkMode] = useState(false);
	const [rtlMode, setRtlMode] = useState(true);
	const [cookies] = useState(["darkMode", "rtlMode"]);

	// useEffect(() => {
	//   const savedDarkMode = cookies.darkMode === "true";
	//   const savedRtlMode = cookies.rtlMode === "true";
	//   setDarkMode(savedDarkMode);
	//   setRtlMode(savedRtlMode);
	// }, []);

	// useEffect(() => {
	//   setCookie("darkMode", darkMode.toString(), { path: "/" });
	// }, [darkMode]);
	// useEffect(() => {
	//   setCookie("rtlMode", rtlMode.toString(), { path: "/" });
	// }, [rtlMode]);

	return (
		<ThemeContext.Provider value={{ darkMode, setDarkMode, rtlMode, setRtlMode }}>
			<ConfigProvider
				locale={fa_IR}
				theme={{
					// single source for the panel's look; prefer changing a token here over overriding .ant-* in SCSS
					token: {
						fontFamily: rtlMode ? "IRANSansX" : "Roboto",
						fontFeatureSettings: "ss03",
						colorPrimary: "#e64225", // --aptel
						colorSuccess: "#37b399", // --green
						colorLink: "#e64225",
						colorLinkHover: "#e64225",
						colorTextBase: "#262626",
						borderRadius: 8,
						// controlHeight stays default: antd derives the header and menu item heights from it
					},
					components: {
						Table: {
							headerBg: "#fafafa",
							headerColor: "#666",
							borderColor: "#ececec",
							rowHoverBg: "#fff8f6",
							cellPaddingInline: 12,
						},
					},
				}}
				direction={rtlMode ? "rtl" : "ltr"}>
				{children}
			</ConfigProvider>
		</ThemeContext.Provider>
	);
};
export function useTheme() {
	return useContext(ThemeContext);
}
